import { SignUpState } from "../../../store/types.tsx";
import handleInitiateSignUp from "./handleInitiateSignUp.tsx";
import handleAgreeToTermsAndConditions from "./handleAgreeToTermsAndConditions.tsx";
import handleAgreeToDataProtectionAgreement from "./handleAgreeToDataProtectionAgreement.ts";
import handleSignupToken from "./handleSignupToken.tsx";
import handleChooseSSOPlatform from "./handleChooseSSOPlatform.tsx";
import handleCompanyName from "./handleCompanyName.tsx";

interface HandleSignUpProps {
  searchText: string;
  dispatch: any;
  signUpState: SignUpState | undefined | null;
}

const handleSignUp = async ({
  searchText,
  dispatch,
  signUpState,
}: HandleSignUpProps) => {
  const trimmedText = searchText.trim().toLowerCase();
  const originalText = searchText.trim();
  console.log(trimmedText);

  if (!signUpState) {
    return handleInitiateSignUp(trimmedText, dispatch);
  }

  if (!signUpState.signUpToken) {
    return handleChooseSSOPlatform(trimmedText, dispatch);
  }

  if (!signUpState.termsAndConditionsHash) {
    return handleSignupToken(trimmedText, dispatch);
  }

  if (!signUpState.companyName) {
    return await handleCompanyName(originalText, dispatch);
  }

  if (!signUpState.dataProtectionPolicyHash) {
    return handleAgreeToTermsAndConditions(trimmedText, dispatch);
  }

  if (!signUpState.isComplete) {
    return handleAgreeToDataProtectionAgreement(
      trimmedText,
      dispatch,
      signUpState,
    );
  }
};
export default handleSignUp;
